
import Header from './components/Header';
import Hero from './components/Hero';
import BeltMap from './components/BeltMap';
import HubDashboard from './components/HubDashboard';
import CategorySection from './components/CategorySection';
import ServiceStack from './components/ServiceStack';
import CaseSection from './components/CaseSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <BeltMap />
      <HubDashboard />
      <CategorySection />
      <ServiceStack />
      <CaseSection />
      <Footer />
    </div>
  );
}